<template>
  <section class="downloadPlugin">
    <v-login-info></v-login-info>
    {{ pcFlag }}
    <!--切换菜单开始-->
    <div class="tab">
      <a v-for="(item, index) in menuList" class="item" :class="{ active : menuIndex === index }" href="javascript: void(0)" @click="meunFn(index)">{{ item }}</a>
    </div>
    <!--切换菜单结束-->

    <!--内容部分开始-->
    <div class="content">
      <!--地图模式插件开始-->
      <div class="mod" v-for="(mod, index) in mapList" :class="{ active : menuIndex === index }">
        <dl class="item" v-for="item in mod.list">
          <dt class="title">{{ item.title }}</dt>
          <a class="down-link" :target="item.blank ? '_blank' : '_self'" :href="item.downLink">{{ item.downLink }}</a>
        </dl>
      </div>
      <!--地图模式插件结束-->
    </div>
    <!--内容部分结束-->
  </section>
</template>

<script type="text/ecmascript-6">
  // 引入用户登录信息组件
  import loginInfo from 'components/loginInfo/loginInfo'
  // 判断客户端来源
  // import {isPc} from 'assets/js/ispc'

  export default {
    // 下载开发插件页面
    name: 'downloadPlugin',
    data () {
      return {
        // 默认菜单索引
        menuIndex: 0,
        menuList: [
          '地图模式插件下载',
          '私服模式插件下载'
        ],
        mapList: [
          {
            list: [
              {
                title: '说明文档下载地址',
                // downLink: `${this.$down.root}/static/down/说明文档.rar`,
                downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Doc/%E8%AF%B4%E6%98%8E%E6%96%87%E6%A1%A3.rar',
                blank: false
              },
              {
                title: '开发插件下载地址(版本号:1.1014756.1014756)',
                downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Creation%26MagicDevelopmentKit/1.1016678.1016678/Creation%26MagicDevelopmentKit-1.1016678.1016678.rar',
                blank: false
              },
              {
                title: 'unity 5.5.4f164位下载地址：（需使用本版本的unity才可以配合《创造与魔法》插件使用）：',
                downLink: 'https://download.unity3d.com/download_unity/8ffd0efd98b1/Windows64EditorInstaller/UnitySetup64-5.5.4f1.exe',
                blank: false
              },
              {
                title: '欢乐射击MOD资源文件下载地址：',
                downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/ModHappyShooting/2018-2-7/%E6%AC%A2%E4%B9%90%E5%B0%84%E5%87%BB%E6%96%87%E4%BB%B6%E5%8C%85.rar',
                blank: false
              },
              /* {
                title: '射箭小游戏教程地址：',
                downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Course/ModShooting.rar',
                blank: false
              }, */
              {
                title: '开发者modhappjump教程：',
                downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Doc/%E5%BC%80%E5%8F%91%E8%80%85modhappyjump%E6%95%99%E7%A8%8B.docx',
                blank: false
              },
              {
                title: '程序架构文档：',
                downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Doc/%E7%A8%8B%E5%BA%8F%E6%9E%B6%E6%9E%84%E6%96%87%E6%A1%A3.docx',
                blank: false
              },
              {
                title: 'NewMODHappJump工程资源文件：',
                downLink: 'http://cmdevelopmentkit.ks3-cn-beijing.ksyun.com/Course/NewModHpaayJumpDeveloper.rar',
                blank: false
              }
            ]
          },
          {
            list: [
              {
                title: '私服MOD正在研发中，敬请期待。',
                downLink: ''
              }
            ]
          }
        ]
      }
    },
    methods: {
      meunFn (index) {
        this.menuIndex = index
      }
    },
    components: {
      'v-login-info': loginInfo
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "downloadPlugin.styl";
</style>



// WEBPACK FOOTER //
// src/views/downloadPlugin/downloadPlugin.vue